import React, { useMemo } from 'react';
import Overlay from '../../../../common/Overlay';
import { useResponsive } from 'hooks/useResponsive';
import * as S from './MainSider.styles';
import { SiderLogo } from '../SiderLogo';
import SiderMenu from '../SiderMenu/SiderMenu';

interface MainSiderProps {
  isCollapsed: boolean;
  setCollapsed: (isCollapsed: boolean) => void;
  isRoot: boolean;
}

const MainSider: React.FC<MainSiderProps> = ({ isCollapsed, setCollapsed, isRoot, ...props }) => {
  const { isDesktop, mobileOnly, tabletOnly } = useResponsive();

  const isCollapsible = useMemo(() => mobileOnly && tabletOnly, [mobileOnly, tabletOnly]);

  const toggleSider = () => setCollapsed(!isCollapsed);

  const factory = window.location.pathname.split('/')[1];
  const isCalib = factory === 'calib';
  const isKaizen = factory === 'kaizen';

  return (
    <>
      <S.Sider
        trigger={null}
        collapsed={factory === 'fac' ? isCollapsed : !isDesktop && isCollapsed}
        collapsedWidth={factory === 'fac' ? (mobileOnly ? 0 : 80) : tabletOnly ? 80 : 0}
        collapsible={isCollapsible}
        width={isCalib ? 280 : factory === 'fac' ? 220 : 260}
        className={isCalib ? 'sider-calib' : isKaizen ? 'sider-kaizen' : undefined}
        {...props}
      >
        <SiderLogo isSiderCollapsed={isCollapsed} toggleSider={toggleSider} />
        <S.SiderContent>
          <SiderMenu setCollapsed={setCollapsed} isRoot={isRoot} isCollapsed={isCollapsed} />
        </S.SiderContent>
      </S.Sider>
      {mobileOnly && <Overlay onClick={toggleSider} show={!isCollapsed} />}
    </>
  );
};

export default MainSider;
